import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createReducer } from '@reduxjs/toolkit';
import { resetStore, setCheckAddressData, setCheckAddressDetails, setFlatForForm, setIsLoading, setMarkerAddressData, setPositionNavButtons, setRenderTooltip } from "./actions";
var initialStore = {
  connected: null,
  flat: '',
  geocodeResults: null,
  highSpeed: null,
  house: '',
  houseFiasId: undefined,
  houseId: 0,
  isLoading: false,
  positionNavButtons: null,
  renderTooltip: false,
  street: '',
  streetFiasId: undefined,
  streetId: 0
};
export var checkAddressReducer = createReducer(initialStore, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, resetStore.type, function (state) {
  return _objectSpread(_objectSpread({}, state), initialStore);
}), setCheckAddressData.type, function (state, action) {
  return _objectSpread(_objectSpread({}, state), action.payload);
}), setCheckAddressDetails.type, function (state, action) {
  var _action$payload = action.payload,
    connected = _action$payload.connected,
    _action$payload$geoco = _action$payload.geocodeResults,
    geocodeResults = _action$payload$geoco === void 0 ? null : _action$payload$geoco,
    highSpeed = _action$payload.highSpeed;
  return _objectSpread(_objectSpread({}, state), {}, {
    connected: connected,
    geocodeResults: geocodeResults,
    highSpeed: highSpeed,
    renderTooltip: true
  });
}), setFlatForForm.type, function (state, _ref) {
  var payload = _ref.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    flat: payload
  });
}), setIsLoading.type, function (state, _ref2) {
  var isLoading = _ref2.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: isLoading
  });
}), setMarkerAddressData.type, function (state, _ref3) {
  var geocodeResults = _ref3.payload.geocodeResults;
  return _objectSpread(_objectSpread({}, state), {}, {
    geocodeResults: geocodeResults
  });
}), setPositionNavButtons.type, function (state, _ref4) {
  var payload = _ref4.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    positionNavButtons: payload
  });
}), setRenderTooltip.type, function (state, _ref5) {
  var renderTooltip = _ref5.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    renderTooltip: renderTooltip
  });
}));